/**
 * gets the array of property  names sorted by the sorter function
 * @param o object which will be sorted
 * @param f the sorter funcitons
 * @return {array}
 */
var orderKeys = function (o, f) {
    var os = [], ks = [], i;
    for (i in o) {
        os.push([i, o[i]]);
    }
    os.sort(function (a, b) {
        return f(a[1], b[1]);
    });
    for (i = 0; i < os.length; i++) {
        ks.push(os[i][0]);
    }
    return ks;
};



/**
 * Finds the given value in the array.
 * @param arr
 * @param val
 * @returns {boolean}
 */
function arraySearch(arr, val) {
    var index;
    for (var i = 0; i < arr.length; i++) {
        // use '===' if you strictly want to find the same type
        if (arr[i] == val) {
            if (index == undefined)
                index = i;
            // return false if duplicate is found
            else
                return false;
        }
    }

    // return false if no element found, or index of the element
    return index == undefined ? false : index;
}
